import { render, staticRenderFns } from "./PublicProjectsList.vue?vue&type=template&id=73015cd2&scoped=true&"
import script from "./PublicProjectsList.vue?vue&type=script&lang=js&"
export * from "./PublicProjectsList.vue?vue&type=script&lang=js&"
import style0 from "./PublicProjectsList.vue?vue&type=style&index=0&id=73015cd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73015cd2",
  null
  
)

export default component.exports